var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{ref:"column",staticClass:"resizable-column",on:{"click":_vm.onClick}},[_c('div',{staticClass:"resizable-area",on:{"mousedown":function($event){$event.preventDefault();$event.stopPropagation();return _vm.handleMouseDown($event)},"click":function($event){$event.stopPropagation();}}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }